import React, { Fragment, useState, useEffect, useRef } from "react";
import { backend, API_URL } from "../../../config";
import {
  Button,
  Typography,
  Modal,
  CircularProgress,
  Container,
  Grid,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Select,
  MenuItem,
} from "@mui/material";

import ManagementNav from "../../../features/OrderManagement/components/Nav/ManagementNav";

import { makeStyles } from "@mui/styles";

const formatTimeAMPM = (timeStr) => {
  if (!timeStr) return "";
  if (timeStr.includes("T")) {
    return new Date(timeStr).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  }
  const timeParts = timeStr.match(/^(\d{1,2}):(\d{2})/);
  if (timeParts) {
    let hours = parseInt(timeParts[1], 10);
    const minutes = timeParts[2];
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${hours}:${minutes} ${ampm}`;
  }
  return timeStr;
};

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600)]: {
      width: 900,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(5),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  tableBody: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

const orderStatusMap = [
  { label: "Invoiced", value: "i" },
  { label: "Submitted", value: "s" },
  { label: "Ready to Print", value: "rp" },
  { label: "Printed", value: "pr" },
  { label: "Review", value: "rv" },
];

export const OrderFollowup = (props) => {
  const classes = useStyles();

  const [cDate] = useState(new Date());

  const [confirmModal, setConfirmModal] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState(cDate);
  const [invoices, setInvoices] = useState([]);
  const [allCompanyLocations, setAllCompanyLocations] = useState([]);
  const [companyLocations, setCompanyLocations] = useState([]);
  const [companyLocationsMapped, setCompanyLocationsMapped] = useState(false);
  const [notifyModal, setNotifyModal] = useState(false);
  const [notifyData, setNotifyData] = useState({
    customer: null,
    to_email: "",
    custom_subject: "",
    note: "",
    loading: false,
  });

  const toggleNotifyModal = (customer) => {
    if (customer && customer.id) {
      const toEmail =
        customer.email ||
        (customer.cc_addresses && customer.cc_addresses.length
          ? customer.cc_addresses[0]
          : "");

      setNotifyData({
        customer,
        to_email: toEmail,
        custom_subject: "",
        note: "",
        loading: false,
      });
      setNotifyModal(true);
    } else {
      setNotifyModal(false);
    }
  };

  const handleNotifyChange = (e) => {
    const { name, value } = e.target;
    setNotifyData((prev) => ({ ...prev, [name]: value }));
  };

  const sendNotifyEmail = async () => {
    if (!notifyData.customer) return;
    setNotifyData((prev) => ({ ...prev, loading: true }));

    // Simulating frontend loading visually
    setTimeout(() => {
      // TODO: Place backend endpoint call here to send email.

      setNotifyData((prev) => ({ ...prev, loading: false }));
      setNotifyModal(false);
    }, 600);
  };

  const updateTimeouts = useRef({});

  const handleOrderFieldChange = (
    companyLocationId,
    orderId,
    fieldName,
    value,
  ) => {
    setCompanyLocations((prevState) =>
      prevState.map((item) => {
        if (item.id === companyLocationId && item.latest_order) {
          return {
            ...item,
            latest_order: {
              ...item.latest_order,
              [fieldName]: value,
            },
          };
        }
        return item;
      }),
    );

    const timeoutKey = `${orderId}-${fieldName}`;
    if (updateTimeouts.current[timeoutKey]) {
      clearTimeout(updateTimeouts.current[timeoutKey]);
    }

    if (value && value.toString().trim() !== "") {
      updateTimeouts.current[timeoutKey] = setTimeout(() => {
        handleOrderFieldBlur(orderId, fieldName, value);
      }, 300);
    }
  };

  const handleOrderFieldBlur = async (orderId, fieldName, value) => {
    try {
      await backend.patch(`${API_URL}orders/${orderId}`, {
        [fieldName]: value,
      });
    } catch (error) {
      console.error(
        `Failed to update ${fieldName} for order ${orderId}`,
        error,
      );
    }
  };

  /* const handleChange = (e) => {
    const { name, checked, value } = e.target;

    const [, invoiceId, fName, ccIndex] = name.split("-");

    setInvoices((prevState) =>
      prevState.map((item) => {
        if (item.order_id !== +invoiceId) return item;

        if (["custom_subject", "note"].includes(fName)) {
          item[fName] = value;
        } else if (name.includes("confirm")) {
          if (name.includes("cc")) {
            item.cc_addresses_confirm[ccIndex] = checked;
          } else {
            item.main_address_confirm = checked;
          }
        } else {
          if (name.includes("cc")) {
            item.company_location_cc_addresses[ccIndex] = value;
          } else {
            item.customer.email = value;
          }
        }

        return item;
      }),
    );
  }; */

  const handleChangeDate = (e) => {
    const { value } = e.target;

    setInvoices([]);
    setDeliveryDate(value);
    setCompanyLocationsMapped(false);
  };

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to share the invoice to the selected emails?
          <div align="right">
            <Button
              onClick={() => toggleConfirmModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Sending Invoice emails <br />
              This may take some time relative to the number of invoices and
              emails
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while sending the emails
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveRequest()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          The selected invoices/emails were sent successfully.
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while generating pdf for the following invoices
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
            </>
          ) : (
            <></>
          )}
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
              className={classes.button}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const resolveRequest = () => {
    setLoadingFlag(false);
    setFinishedFlag(false);
    toggleConfirmModal();
    setErrorInfo({ error: false, message: "" });
  };

  const sendRequest = () => {};

  /* const sendRequest = async () => {
    setLoadingFlag(true);

    const invoicesToShare = invoices.filter((item) => {
      if (item.main_address_confirm && item.customer.email !== "") return true;

      if (item.cc_addresses_confirm !== null) {
        return item.cc_addresses_confirm.some((cItem) => cItem);
      }

      return false;
    });

    let errorMsg = "";

    // todo: create a getInvoice to make sure we totalize the subitem weight lbs and lot code counts
    Promise.all(
      invoicesToShare.map(
        async (iItem) =>
          await getInvoice(iItem.order_id).then(async (data) => {
            const toEmail = iItem.main_address_confirm
              ? iItem.customer.email
              : "";

            if (toEmail !== "") {
              try {
                const pdfFile = generateDocument(data);

                let invoiceFormData = new FormData();

                invoiceFormData.append("file", pdfFile);
                invoiceFormData.append("to_email", toEmail);

                if (iItem.cc_addresses_confirm !== null) {
                  iItem.cc_addresses_confirm.forEach((item, index) => {
                    if (item) {
                      invoiceFormData.append(
                        `additional_emails[${index}]`,
                        iItem.company_location_cc_addresses[index]
                      );
                    }
                  });
                }

                if (iItem.custom_subject !== "") {
                  invoiceFormData.append(
                    "custom_subject",
                    iItem.custom_subject
                  );
                }

                if (iItem.note !== "") {
                  invoiceFormData.append("note", iItem.note);
                }

                await backend.post(
                  `${API_URL}orders/${iItem.order_id}/invoice/email`,
                  invoiceFormData,
                  {
                    headers: { "Content-Type": "multipart/form-data" },
                  }
                );

                return invoiceFormData;
              } catch (error) {
                console.log(error);
                errorMsg +=
                  "\nThere was an error processing Invoice: " + iItem.order_id;

                return error;
              }
            }
          })
      )
    ).then(() => {
      if (errorMsg) {
        setErrorInfo({ error: true, message: errorMsg });
      }

      setLoadingFlag(false);
      setFinishedFlag(true);
    });
  }; */

  useEffect(() => {
    const companyLocationsGet = async () => {
      await backend
        .get(`${API_URL}companylocations?no_page=1`)
        .then(({ data }) => {
          const dataMap = data.map((item) =>
            item.id === 166
              ? {
                  ...item,
                  delivery_hour: "06:00:00 AM",
                }
              : item,
          );
          setAllCompanyLocations(dataMap);
          setCompanyLocationsMapped(false);
        });
    };

    companyLocationsGet();
  }, []);

  useEffect(() => {
    const getOrders = async () => {
      let deliveryDateObj = new Date(deliveryDate);

      const deliveryDateParam = new Date(
        deliveryDateObj.getTime() - deliveryDateObj.getTimezoneOffset() * 60000,
      )
        .toISOString()
        .split("T")[0];

      await backend
        .get(
          `${API_URL}orders?no_page=1&start_date=${deliveryDateParam}&end_date=${deliveryDateParam}`,
        )
        .then(({ data }) => {
          setCompanyLocations(() => {
            const daysArr = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
            const selectedDayStr = daysArr[deliveryDateObj.getDay()];

            const parseTime = (timeStr) => {
              if (!timeStr) return Number.MAX_SAFE_INTEGER;
              if (timeStr.includes("T")) return new Date(timeStr).getTime();
              const d = new Date(`1970/01/01 ${timeStr}`);
              if (!isNaN(d)) return d.getTime();
              return Number.MAX_SAFE_INTEGER;
            };

            return allCompanyLocations
              .filter(
                (item) =>
                  item.order_days && item.order_days.includes(selectedDayStr),
              )
              .map((item) => {
                const companyLocationOrder = data.find(
                  (oItem) => oItem?.company_location?.id === item.id,
                );

                return {
                  ...item,
                  latest_order: companyLocationOrder || null,
                };
              })
              .sort((a, b) => {
                const timeA = parseTime(a.delivery_time || a.delivery_hour);
                const timeB = parseTime(b.delivery_time || b.delivery_hour);
                return timeA - timeB;
              });
          });
          setCompanyLocationsMapped(true);
        });
    };

    if (
      deliveryDate !== null &&
      allCompanyLocations.length &&
      !companyLocationsMapped
    ) {
      getOrders();
    }
  }, [allCompanyLocations, companyLocationsMapped, deliveryDate]);

  const notifyModalContent = (
    <div className={classes.modal}>
      {notifyData.loading ? (
        <div align="center">
          <CircularProgress />
        </div>
      ) : (
        <>
          <Grid container spacing={2} style={{ alignItems: "center" }}>
            <Grid item xs={12}>
              Customer: <b>{notifyData.customer?.name || ""}</b>
              <br />
              Phone Number: {notifyData.customer?.phone_number || ""}
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                id="outlined-basic"
                variant="outlined"
                label="Email To"
                name="to_email"
                autoComplete="email"
                value={notifyData.to_email}
                onChange={handleNotifyChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                id="outlined-basic"
                variant="outlined"
                label="Custom Subject"
                name="custom_subject"
                autoComplete="off"
                value={notifyData.custom_subject}
                onChange={handleNotifyChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={4}
                size="small"
                id="outlined-basic"
                variant="outlined"
                label="Note"
                name="note"
                autoComplete="off"
                value={notifyData.note}
                onChange={handleNotifyChange}
              />
            </Grid>
          </Grid>
          <br />
          <div align="right">
            <Button
              onClick={() => toggleNotifyModal(null)}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={sendNotifyEmail}
              className={classes.button}
              style={{ marginLeft: 8 }}
            >
              Send
            </Button>
          </div>
        </>
      )}
    </div>
  );

  // todo: remove when we use or figure out invoices state usage
  console.log(invoices);

  return (
    <Container>
      <Modal open={confirmModal} onClose={toggleConfirmModal}>
        {confirmModalContent}
      </Modal>
      <Modal open={notifyModal} onClose={toggleNotifyModal}>
        {notifyModalContent}
      </Modal>
      <ManagementNav {...props} />
      <Typography component="h6" variant="h6" align="center">
        Order Follow-up
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}></Grid>
        <Grid item xs={12} sm={12}>
          Use this interface to follow-up on placed orders and customers that
          have not placed an order yet.
        </Grid>
        <Grid item xs={12} sm={12}></Grid>
        <Grid item xs={12} sm={12}>
          Load orders from a given date.
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="delivery-date"
            label="Delivery date"
            type="date"
            fullWidth
            variant="standard"
            value={
              deliveryDate instanceof Date
                ? new Date(
                    deliveryDate.getTime() -
                      deliveryDate.getTimezoneOffset() * 60000,
                  )
                    .toISOString()
                    .split("T")[0]
                : typeof deliveryDate === "string"
                  ? deliveryDate.split("T")[0]
                  : ""
            }
            onChange={(e) => {
              const val = e.target.value;
              if (val) {
                const [y, m, d] = val.split("-");
                const newDate = new Date(y, m - 1, d);
                handleChangeDate({
                  target: {
                    name: "delivery_date",
                    value: newDate,
                  },
                });
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {}}
            className={classes.button}
          >
            Bulk Notify All
          </Button>
        </Grid>
        <Grid item xs={12} sm={12}></Grid>
        {companyLocationsMapped ? (
          <TableContainer style={{ maxHeight: "80vh" }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell size="small">Customer</TableCell>
                  <TableCell size="small">Pre-Pulled By</TableCell>
                  <TableCell size="small">Pulled By</TableCell>
                  <TableCell size="small">Palletized By</TableCell>
                  <TableCell size="small">Notes</TableCell>
                  <TableCell size="small">Status</TableCell>
                  <TableCell size="small">Delivery Hour</TableCell>
                  <TableCell size="small">Notified</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {companyLocations.map((item) => (
                  <TableRow
                    key={`company_location-${item.id}`}
                    hover
                    tabIndex={-1}
                  >
                    <TableCell size="small">
                      <b>{item.name}</b>
                    </TableCell>
                    <TableCell size="small">
                      {item.latest_order ? (
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          label="Pre Pulled By: "
                          value={item.latest_order.prepulled_by || ""}
                          onChange={(e) =>
                            handleOrderFieldChange(
                              item.id,
                              "prepulled_by",
                              e.target.value,
                            )
                          }
                          onBlur={(e) =>
                            handleOrderFieldBlur(
                              item.latest_order.id,
                              "prepulled_by",
                              e.target.value,
                            )
                          }
                        />
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell size="small">
                      {item.latest_order ? (
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          label="Pulled By: "
                          value={item.latest_order.pulled_by || ""}
                          onChange={(e) =>
                            handleOrderFieldChange(
                              item.id,
                              "pulled_by",
                              e.target.value,
                            )
                          }
                          onBlur={(e) =>
                            handleOrderFieldBlur(
                              item.latest_order.id,
                              "pulled_by",
                              e.target.value,
                            )
                          }
                        />
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell size="small">
                      {item.latest_order ? (
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          label="Palletized By: "
                          value={item.latest_order.palletized_by || ""}
                          onChange={(e) =>
                            handleOrderFieldChange(
                              item.id,
                              "palletized_by",
                              e.target.value,
                            )
                          }
                          onBlur={(e) =>
                            handleOrderFieldBlur(
                              item.latest_order.id,
                              "palletized_by",
                              e.target.value,
                            )
                          }
                        />
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell size="small">
                      {item.latest_order ? (
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          label="Notes: "
                          value={item.latest_order.note || ""}
                          onChange={(e) =>
                            handleOrderFieldChange(
                              item.id,
                              "note",
                              e.target.value,
                            )
                          }
                          onBlur={(e) =>
                            handleOrderFieldBlur(
                              item.latest_order.id,
                              "note",
                              e.target.value,
                            )
                          }
                        />
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell size="small">
                      {item.latest_order ? (
                        <Select
                          fullWidth
                          size="small"
                          name={`company_location-${item.id}-status`}
                          value={item.latest_order.status || ""}
                          onChange={(e) => {
                            handleOrderFieldChange(
                              item.id,
                              item.latest_order.id,
                              "status",
                              e.target.value,
                            );
                          }}
                        >
                          {orderStatusMap.map((oStatus) => (
                            <MenuItem
                              key={`company_location-${item.id}-status-${oStatus.value}`}
                              value={oStatus.value}
                            >
                              {oStatus.label}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell size="small">
                      <b>
                        {formatTimeAMPM(
                          item.delivery_time || item.delivery_hour,
                        )}
                      </b>
                    </TableCell>
                    <TableCell size="small">
                      {!item.latest_order ? (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => toggleNotifyModal(item)}
                          className={classes.button}
                        >
                          Notify
                        </Button>
                      ) : (
                        ""
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <></>
        )}
      </Grid>
    </Container>
  );
};

export default OrderFollowup;
